import React from "react";

import "./AgentsTableFooter.scss";

//i18n
import { withTranslation } from "react-i18next";

const index = ({ t, ...props }) => {
  return (
    <div className="d-flex justify-content-between mt-3 mr-4">
      <span id="current-agents-number" className="text-dark">
        {props.minimumAgentNumber} - {props.maxAgentNumber}
      </span>
      {t("of")}
      <span id="total-agents-number" className="text-dark">
        {props.totalAgentNumber}
      </span>
      {t("agents")}
    </div>
  );
};

export default withTranslation()(index);
